import { useState } from "react";
import { HelpCircle } from "lucide-react";

const FAQ = ({ faqs = [] }) => {
  const [open, setOpen] = useState(null);

  const hasFAQs = Array.isArray(faqs) && faqs.length > 0;

  return (
    <div>
      <h2 className="lg:text-2xl text-lg font-semibold mb-6">
        Frequently Asked Questions
      </h2>

      <div className="rounded-xl border border-gray-200 bg-white px-6 py-6">
        {/* Empty State */}
        {!hasFAQs && (
          <div className="text-center py-10">
            <HelpCircle size={40} className="mx-auto text-gray-300 mb-4" />
            <p className="text-gray-500 text-sm">
              No FAQs available yet for this creator.
            </p>
          </div>
        )}

        {/* FAQ List */}
        {hasFAQs &&
          faqs.map((f, i) => (
            <div key={i} className="border-b last:border-none py-4">
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex justify-between items-center font-medium text-left"
              >
                <span>{f.q}</span>
                <span className="text-lg">
                  {open === i ? "−" : "+"}
                </span>
              </button>

              {open === i && (
                <p className="mt-3 text-gray-600 text-sm leading-relaxed">
                  {f.a}
                </p>
              )}
            </div>
          ))}
      </div>
    </div>
  );
};

export default FAQ;

